const t = {
  position: "absolute",
  width: "100%",
  height: "100%",
  top: 0,
  left: 0
};
export {
  t as spinnerContainer
};
